import React from 'react';
import { ListGroup, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Item = (props) => {
  const { data } = props;

  const handleOnClick = () => {
    props.onRowClick(props.data);
  };

  const handleCheckboxClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const show = (hidde) => {
    return (
      <FontAwesomeIcon
        icon={['fa', 'check']}
        size="md"
      />
    );
  };

  return (
    <ListGroup.Item
      action
      onClick={handleOnClick}
      className="d-flex align-items-start"
    >
      {data.checked ? show() : <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>}

      <Form>
        <Form.Check
          type="checkbox"
          hidden
          name={data.key}
          label={data.title}
          checked={data.checked || false}
          onChange={handleCheckboxClick}
        />
      </Form>
    </ListGroup.Item>
  );
};

export default Item;
